module.exports = __webpack_public_path__ + "static/media/017ty@2x.06f3efd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/017ty@2x.png
// module id = 1667
// module chunks = 0 1